import React, {useMemo} from "react";
import styles from "./FFKHistory.module.scss";
import History from "../../assets/images/kos-his.jpg"
import Kryesite from "./Kryesite";
import Kampionet from "./Kampionet";
import Kampionet1945 from "./Kampionet1945";
import {useTranslation} from "react-i18next";

const FFKHistory = () => {

  const { t } = useTranslation();

  return (
      <div className={styles.MainWrapper}>
        <div className={styles.PrimaryTitleWrapper}>
          <div className={styles.FFkHistoryContainer}>
            <div className={styles.ListWrapper}>
              <h1>Historiku i FFK</h1>
              <img src={History}/>
              <p> {t("ffkHistory.paragraph1", "")}
                <br/> <br/>
                {t("ffkHistory.paragraph2", "")}
                <br/> <br/>
                {t("ffkHistory.paragraph3", "")}
                <br/> <br/>
                {t("ffkHistory.paragraph4", "")}
                <br/> <br/>
                {t("ffkHistory.paragraph5", "")}
              </p>

              <Kryesite/>
              <Kampionet/>
            </div>

            <div className={styles.ListWrapper}>
            <h2>Historiku i shkurtër i futbollit në Kosovë 1919-1991</h2>
              <p>
                {t("ffkHistory.paragraph6", "")}
                <br/><br/>
                {t("ffkHistory.paragraph7", "")}
                <br/><br/>
                {t("ffkHistory.paragraph8", "")}
                <br/><br/>
                {t("ffkHistory.paragraph9", "")}
                <br/><br/>
                {t("ffkHistory.paragraph10", "")}
                <br/><br/>
                {t("ffkHistory.paragraph11", "")}
                <br/><br/>
                {t("ffkHistory.paragraph12", "")}
                <br/><br/>
                {t("ffkHistory.paragraph13", "")}
              </p>

              <Kampionet1945/>
            </div>
          </div>
        </div>
      </div>
  );
};

export default FFKHistory;
